// Shared table formatting helpers used across admin tables

/**
 * Join list for tooltip with optional prefix shown before each item.
 */
export const listToTooltip = (items: string[], prefix?: string): string => {
  const lines = items.map((item) => `${prefix ? prefix + ': ' : ''}${item}`);
  return lines.join('\n');
};

/**
 * Format a summarized list: show first N items, then "+X more".
 */
export const summarizeList = (items: string[], maxVisible: number = 2): string => {
  if (items.length <= maxVisible) return items.join(', ');
  const shown = items.slice(0, maxVisible).join(', ');
  return `${shown}, +${items.length - maxVisible} more`;
};


